'use strict';

(function () {

  angular.module('specsguardApp')
    .config(UserConfig);

  UserConfig.$inject = ['$stateProvider'];

  function UserConfig ($stateProvider) {

    $stateProvider.state('user', {
      url: '/user',
      templateUrl: 'app-legacy/user/user.html',
      menu: {
        context: 'users',
        title: '[Gebruikers]',
        icon: 'people',
        subtitle: '[Overzicht]'
      },
      controller: 'UserCtrl',
      controllerAs: '$UserCtrl',
      authenticate: true,
      needRole: 8,
      resolve: {
        users: ['User', function (User) {
          return User.getAll().$promise;
        }],
        allProjects: ['ProjectDataservice', function (ProjectDataservice) {
          return ProjectDataservice.getProjectList();
        }],
      }
    });
  }

})();


